import { MobileNumberForFrenchLeader } from '../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader'
import { MobileNumberForFrenchLeaderInput } from '../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createMobileNumberForFrenchLeader = async (
  input: MobileNumberForFrenchLeaderInput & { olId: number }
) => {
  const { olId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.ols.createMobileNumberForFrenchLeader.url, { olId }))
    .post<MobileNumberForFrenchLeader, MobileNumberForFrenchLeaderInput>(data)
}
